export default "__VITE_ASSET__ImH$XjJK__"